function getComp(data, type, nameType = 'short_name') {
  try {
    return data.address_components.find(c => c.types.includes(type))[nameType]
  } catch (error) {
    return ''
  }
}

function getFormattedAddressFromGoogleAddress(data) {
  const city =
    getComp(data, 'locality', 'long_name') ||
    getComp(data, 'sublocality', 'long_name') ||
    getComp(data, 'administrative_area_level_3', 'long_name')
  const stateCode = getComp(data, 'administrative_area_level_1')
  const countryCode = getComp(data, 'country')
  const postalCode = getComp(data, 'postal_code')
  const streetAddress = `${getComp(data, 'street_number')} ${getComp(data, 'route')}`

  return {
    city,
    stateCode,
    countryCode,
    postalCode,
    streetAddress,
    placesId: data.place_id
  }
}

export default getFormattedAddressFromGoogleAddress
